var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155 155",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    className: "style-scope yt-icon",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    viewBox: "0 0 155 155",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 27.3)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .7h125.5V99H0z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.6 40.4C6.6 16.6 26.5.8 54.7.7 77.2.7 89.2 8 101 15.6c18.5 12.1 27 24.6 24 41.8-5 26.4-22.6 41.3-64.3 41.6-41.8.2-67.5-17.7-59-58.6",
    fill: "#EEE",
    mask: "url(1)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.1 47.8s21.2 11.4 23.7 12.9c2.1 1.2 2.1 3.3.3 4.9l-17.2 15L63 47.8z",
    fill: "#00D4B5",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 83.3)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.9 0h77.3v43H.9z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.7.7C30.7 5 4.4 13.7 2.2 23.6L1 29.7C11.4 40.2 26.7 43.1 48.6 43c11.6 0 21.4-1 29.6-3-2.2-3.3-5-9.5-7.9-16.8C63.8 6.9 48-2.5 40.7.7",
    fill: "red",
    mask: "url(#account_notifications__d)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.4 102.4c5.5.2 4.4 7.6 10.6 8.5 6.4 1 7.3-8.3 12.9-8.2 5.6.2 6.1 9.3 13.7 8.2 5.6-.8 4.5-8 9.5-9.2 4.7-1 5.3 5.6 11.2 4.7-6.5-16.3-12.8-51-20.2-58.6-3.6-3.7-15.9-3.1-23.1 0-10 4.4-15.6 7.7-18 24.5 0 0-4.8 25.8-6.8 34.5 6 .7 5.6-4.4 10.2-4.4",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4 43.5c-9.8 4.3-14.8 11.8-17.3 27.9l41-23.6c-7.4-5.8-17.6-7-23.7-4.3",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3 51.5a1.5 1.5 0 0 1-.8-2.8L71 40.1a1.5 1.5 0 0 1 1.5 2.6L57 51.3c-.2.2-.5.2-.7.2",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 70a8.4 8.4 0 0 1 9-7c.4 0 5.2 4.9 4.1 9.6-.8 3.9-2.7 7.9-2.7 7.9h-3.3c-5-.8-8-5.1-7-10.4",
    fill: "#FFF",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85 56.3)",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#fff",
    className: "style-scope yt-icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.3.5H69v40.6H.3z",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.6.5h40.1c3.5 0 9 0 6.7 6.2-2.3 6.4-9.3 25-11.2 28.7-1.8 3.7-4.5 5.7-9.3 5.7H7c-2 0-8.2-2-6.2-7.5 2-5.5 9.5-22.7 11.7-26.9C14.6 2.6 16 .5 21.6.5",
    fill: "#00D4B5",
    mask: "url(#account_notifications__f)",
    className: "style-scope yt-icon"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59 73.3c1-4.8-1.9-9.2-7.2-10.2l-1.4-.1c-3.7 3.9-2.1 13.4 1.5 17.4a8.7 8.7 0 0 0 7-7",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 125.7A179.2 179.2 0 0 1 93.5 89c6.5-8.3 12.5-9.4 14.4-8.9 1.9.5-4.4 12.6-4.4 12.6s7-10.5 12.4-7.5c1.3.7-3.4 11.9-3.4 11.9s6-9.7 11.4-7c2.6 1.2-6.8 24.3-24.4 31.6-5.2 2.2-14.3 4.1-24.7 4.1",
    fill: "#FF76DA",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.2 77.4c-2 0-3.7-.7-5-2.1-1.5-1.9-8.6-10-11.7-13.5a.7.7 0 1 1 1.1-1c3.1 3.4 10.3 11.6 11.8 13.5 1.5 1.8 5 2.5 9.3-.2l15-8.2c3.4-2 6.7-3.8 9.1-5a.7.7 0 1 1 .7 1.2l-9.1 5-14.9 8.3c-2.2 1.3-4.3 2-6.3 2",
    fill: "#FFF",
    className: "style-scope yt-icon"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 41.6c.3-1.5 1.7-2.3 3.1-2 1.6.2 2.5 1.6 2.2 3a2.6 2.6 0 0 1-3.1 2.2c-1.6-.3-2.5-1.6-2.2-3.2M78.3 67.2c-1.7 0-3.7-1.1-4.2-4.3a.7.7 0 1 1 1.5-.3c.3 2.5 1.8 3.2 3 3a2.8 2.8 0 0 0 2.5-2.9c0-.4.3-.8.7-.8.4 0 .7.3.8.7a4.3 4.3 0 0 1-4.3 4.6",
    fill: "#4620AE",
    className: "style-scope yt-icon"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.2fd11b9abbfffe5147cc0eecb94ff495.svg";
export { ForwardRef as ReactComponent };